import HomeMenu from "../components/HomeMenu";

const HomePage = () => {
  document.title = "Главная | Сакурамант";

  return <HomeMenu />;
};

export default HomePage;
